import Image from 'next/image';
import { useTranslations } from 'next-intl';
import { use } from 'react';
import { Button } from '@/components/ui/button';
import {
  Dialog,
  DialogContent,
  DialogDescription,
  DialogFooter,
  DialogHeader,
  DialogTitle,
} from '@/components/ui/dialog';
import { PushNotificationContext } from '../context/PushNotificationContext';

export function NotificationBlockedDialog() {
  const t = useTranslations('notifications');
  const pushNotification = use(PushNotificationContext);
  if (!pushNotification) throw new Error('PushNotificationContext not found');
  const { showDeniedDialog, setShowDeniedDialog } = pushNotification;

  return (
    <Dialog open={showDeniedDialog} onOpenChange={setShowDeniedDialog}>
      <DialogContent className='px-4'>
        <DialogHeader className='flex flex-col items-center'>
          <Image
            src='/images/notifications/girl-happy.svg'
            alt='Notification Blocked'
            width={76}
            height={116}
            className='mb-6'
          />

          <DialogTitle>{t('dialogs.notificationsBlocked.title')}</DialogTitle>
          <DialogDescription className='text-center text-gray-700'>
            {t('dialogs.notificationsBlocked.description')}
          </DialogDescription>
        </DialogHeader>
        <DialogFooter className='flex-col gap-2'>
          <Button
            variant='tertiary'
            onClick={() => setShowDeniedDialog(false)}
            size='medium'
            className='w-[100px]'
          >
            {t('buttons.close')}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
